import { useEffect, useState, useCallback } from "react";

const DEFAULTS = {
  deepseek: { temperature: 0.7, max_tokens: 1500 },
  qwen:     { temperature: 0.7, max_tokens: 1500 },
  kimi:     { temperature: 0.8, max_tokens: 1500 },
  llama:    { temperature: 0.7, max_tokens: 1500 },
};

const KEY = "aimedley.model_settings.v1";

function load() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      deepseek: { ...DEFAULTS.deepseek, ...parsed.deepseek },
      qwen:     { ...DEFAULTS.qwen,     ...parsed.qwen },
      kimi:     { ...DEFAULTS.kimi,     ...parsed.kimi },
      llama:    { ...DEFAULTS.llama,    ...parsed.llama },
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function useModelSettings() {
  const [settings, setSettings] = useState(load);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setSettings(load());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const update = useCallback((model, patch) => {
    setSettings((prev) => {
      const next = { ...prev, [model]: { ...prev[model], ...patch } };
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
      // notify other tabs/components in same tab
      window.dispatchEvent(new StorageEvent("storage", { key: KEY }));
      return next;
    });
  }, []);

  const reset = useCallback((model) => {
    setSettings((prev) => {
      const next = model
        ? { ...prev, [model]: { ...DEFAULTS[model] } }
        : { ...DEFAULTS };
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
      window.dispatchEvent(new StorageEvent("storage", { key: KEY }));
      return next;
    });
  }, []);

  return { settings, update, reset, defaults: DEFAULTS };
}
